function requestResetPassword() {
    let url = "/ajax/usermanagement/requestResetPassword.php";

    let postObj = {};
    postObj.get_mail = get_mail;
    postObj.get_token = get_token;
    postObj.get_action = "request_password_reset";

    newPostAjax(url, afterRequestResetPassword, postObj);
}